import React from 'react'

import Icon from 'Shared/atoms/Icon'
import BrandFooter from 'Shared/organisms/BrandFooter'

import { MAIN_DESCRIPTION } from './constants'

import styles from './styles.module.scss'

const SmallScreenStub: React.FC = () => (
	<div className={styles.wrapper}>
		<div className={styles.header}>
			<Icon type="brandLogo" />
		</div>
		<div className={styles.content}>
			<Icon type="wavingHand" />
			<span className={styles.description} children={MAIN_DESCRIPTION} />
		</div>
		<div className={styles.footer}>
			<BrandFooter wrapperClassName={styles.brandFooter} />
		</div>
	</div>
)

export default React.memo(SmallScreenStub)
